<template>
  <div class="row header">
    <div class="col-8 title">{{ $t(title) }} <strong v-if="count">{{ count }}</strong></div>
    <div class="col-4 action">
      <span @click="viewDetail">{{ $t('common.more') }} &gt;</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'cat-subtitle',

    props: [
      'title',
      'count',
      'routeName',
      'eventLabel',
    ],

    methods: {
      viewDetail() {
        this.$ga.event({
          eventCategory: 'learning',
          eventLabel: this.eventLabel,
          eventAction: 'click',
        });

        return this.$router.push({ name: this.routeName });
      },
    },

  };
</script>

<style lang="scss" scoped>
  .header {
    padding: 20px 14px 20px 14px;

    .title {
      font-size: 18px;
      padding: 0;

      strong {
        color: #00c896;
      }
    }
  
    .action {
      font-size: 12px;
      text-align: right;
      float: right;

      span {
        color: rgba(0, 0, 0, 0.6);
        text-decoration:none;
        cursor: pointer;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// CatSubtitle.vue?15814dc5